import {createTheme, ThemeOptions} from "@mui/material";
import {DEFAULT_THEME_OPTIONS, nightGray} from "@/shared/colors";
import {CARD_SHADOW, PD_LG, PD_XSM} from "@/shared/dimens";
import {SiteTemplate} from "../../types";
import {AddressSection} from "./AddressSection";
import {ContactSection} from "./ContactSection";
import {FaqSection} from "./FaqSection";
import {FooterSection} from "./FooterSection";
import {GallerySection} from "./GallerySection";
import {HeaderSection} from "./HeaderSection";
import {HeroSection} from "./HeroSection";
import {HighlightSection} from "./HighlightSection";
import {PromoSection} from "./PromoSection";
import {ServicesSection} from "./ServicesSection";
import {StatsSection} from "./StatsSection";
import {TeamSection} from "./TeamSection";
import {TestimonialsSection} from "./TestimonialsSection";
import {FontManager} from "@/shared/fonts";

const fontManager = FontManager.getInstance();
export const HeadingFont = fontManager.getFont("Josefin_Sans");
export const BodyFont = fontManager.getFont("Raleway");

export const THEME_OPTIONS: ThemeOptions = {
  ...DEFAULT_THEME_OPTIONS,
  shape: {
    borderRadius: 0,
  },
  components: {
    ...DEFAULT_THEME_OPTIONS.components,
    MuiPaper: {
      styleOverrides: {
        elevation: {
          boxShadow: CARD_SHADOW,
        },
      },
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          fontWeight: "700",
          borderRadius: 0,
          minHeight: 48,
          paddingTop: PD_XSM,
          paddingBottom: PD_XSM,
          paddingLeft: PD_LG,
          paddingRight: PD_LG,
          textTransform: "none",
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        arrow: {
          backgroundColor: nightGray,
        },
        tooltip: {
          backgroundColor: nightGray,
          fontSize: "90%",
        },
      },
    },
  },
  typography: {
    h1: {
      fontWeight: "700",
      fontSize: "4rem",
      letterSpacing: "0.06em",
      textTransform: "uppercase",
      fontFamily: HeadingFont.style.fontFamily,
      lineHeight: 1.0,
    },
    h2: {
      fontWeight: "700",
      fontSize: "3rem",
      letterSpacing: "0.05em",
      textTransform: "uppercase",
      fontFamily: HeadingFont.style.fontFamily,
      lineHeight: 1.05,
    },
    h3: {
      fontWeight: "700",
      fontSize: "1.9rem",
      letterSpacing: "0.08em",
      textTransform: "uppercase",
      fontFamily: HeadingFont.style.fontFamily,
    },
    h4: {
      fontWeight: "700",
      fontSize: "1.3rem",
      letterSpacing: "0.04em",
      textTransform: "uppercase",
      fontFamily: HeadingFont.style.fontFamily,
    },
    h5: {
      fontWeight: "400",
      fontSize: "1.1rem",
      letterSpacing: "0.04em",
      fontFamily: HeadingFont.style.fontFamily,
    },
    h6: {
      fontWeight: "600",
      letterSpacing: "0.03em",
      fontFamily: HeadingFont.style.fontFamily,
    },
    fontSize: 16,
    fontFamily: BodyFont.style.fontFamily,
  },
  palette: {
    primary: {
      main: "#FF0090",
      contrastText: "#fff",
    },
    secondary: {
      main: "#FFF0FA",
      contrastText: "#FF0090",
    },
  },
};

export const FLORIDA_TEMPLATE: SiteTemplate = {
  name: "florida",
  text: "Florida",
  theme: createTheme(THEME_OPTIONS),
  themeExtras: {
    highlightColor: "#FFF0FA",
  },
  PageSections: {
    AddressSection: AddressSection,
    ContactSection: ContactSection,
    FaqSection: FaqSection,
    FooterSection: FooterSection,
    GallerySection: GallerySection,
    HeaderSection: HeaderSection,
    HeroSection: HeroSection,
    HighlightSection: HighlightSection,
    PromoSection: PromoSection,
    ServicesSection: ServicesSection,
    StatsSection: StatsSection,
    TeamSection: TeamSection,
    TestimonialsSection: TestimonialsSection,
  },
};
